import React from 'react';
import AdminDashboard from '../components/AdminDashboard';

const AdminDashboardApp = (props) => <AdminDashboard {...props} />;

export default AdminDashboardApp;
